/* Parquelectro - coleccion + busqueda: barra de control + slider doble + Ordenar por + copiar SKU */
(function () {
  'use strict';

  function facetScope() { return document.getElementById('main-collection-filters') || document.getElementById('main-search-filters'); }

  function parseAR(s) {
    if (s == null) return null;
    s = String(s).trim();
    if (s === '') return null;
    s = s.replace(/\./g, '').replace(',', '.');
    var n = Number(s);
    return isNaN(n) ? null : n;
  }
  function fmtAR(n) {
    return Number(n).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function moveTopBar() {
    var bar = document.querySelector('.facets-vertical-sort');
    if (!bar) return;
    var form = bar.querySelector('.facets-vertical-form') || bar;
    var active = document.querySelector('.active-facets-desktop');
    if (active && form && !form.contains(active)) {
      var sorting = form.querySelector('.facet-filters.sorting');
      if (sorting) form.insertBefore(active, sorting);
      else form.appendChild(active);
    }
  }

  function openPrice() {
    var scope = facetScope();
    if (!scope) return;
    scope.querySelectorAll('details.js-filter').forEach(function (d) {
      var s = d.querySelector('summary');
      if (s && /precio|price/i.test(s.textContent) && !d.open) d.open = true;
    });
  }

  var CARET = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';

  function buildSort() {
    var sorting = document.querySelector('.facets-vertical-sort .facet-filters.sorting');
    if (!sorting || sorting.querySelector('.pe-sort')) return;
    var sel = sorting.querySelector('#SortBy');
    if (!sel) return;
    var selWrap = sel.closest('.select');
    var field = sorting.querySelector('.facet-filters__field') || sorting;

    var wrap = document.createElement('div');
    wrap.className = 'pe-sort';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pe-sort__btn';
    btn.innerHTML = 'Ordenar por ' + CARET;
    var menu = document.createElement('div');
    menu.className = 'pe-sort__menu';

    Array.prototype.forEach.call(sel.options, function (o) {
      var it = document.createElement('button');
      it.type = 'button';
      it.className = 'pe-sort__opt' + (o.selected ? ' is-active' : '');
      it.textContent = o.textContent.trim();
      it.setAttribute('data-value', o.value);
      it.addEventListener('click', function () {
        sel.value = o.value;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        menu.querySelectorAll('.pe-sort__opt').forEach(function (x) { x.classList.remove('is-active'); });
        it.classList.add('is-active');
        wrap.classList.remove('is-open');
      });
      menu.appendChild(it);
    });

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      wrap.classList.toggle('is-open');
    });

    wrap.appendChild(btn);
    wrap.appendChild(menu);
    if (selWrap) selWrap.style.display = 'none';
    field.appendChild(wrap);
  }

  document.addEventListener('click', function () {
    var o = document.querySelector('.pe-sort.is-open');
    if (o) o.classList.remove('is-open');
  });

  function buildSlider() {
    var scope = facetScope();
    if (!scope) return;
    var pr = scope.querySelector('price-range.facets__price');
    if (!pr || pr.querySelector('.pe-slider')) return;
    var ins = pr.querySelectorAll('input.field__input');
    if (ins.length < 2) return;
    var gte = ins[0], lte = ins[1];
    var min = parseAR(gte.getAttribute('data-min'));
    if (min == null) min = 0;
    var max = parseAR(gte.getAttribute('data-max'));
    if (max == null) max = parseAR(lte.getAttribute('data-max'));
    if (max == null || max <= min) max = min + 1;
    var step = Math.max(1, Math.round((max - min) / 1000));
    var vMin = parseAR(gte.value); if (vMin == null) vMin = min;
    var vMax = parseAR(lte.value); if (vMax == null) vMax = max;

    var wrap = document.createElement('div');
    wrap.className = 'pe-slider';
    wrap.innerHTML =
      '<div class="pe-slider__rail"><div class="pe-slider__fill"></div></div>' +
      '<input type="range" class="pe-slider__thumb pe-slider__thumb--min" min="' + min + '" max="' + max + '" step="' + step + '" value="' + vMin + '" aria-label="Precio minimo">' +
      '<input type="range" class="pe-slider__thumb pe-slider__thumb--max" min="' + min + '" max="' + max + '" step="' + step + '" value="' + vMax + '" aria-label="Precio maximo">';
    pr.insertBefore(wrap, pr.firstChild);

    var tmin = wrap.querySelector('.pe-slider__thumb--min');
    var tmax = wrap.querySelector('.pe-slider__thumb--max');
    var fill = wrap.querySelector('.pe-slider__fill');

    function paint() {
      var a = Number(tmin.value), b = Number(tmax.value);
      if (a > b) { var t = a; a = b; b = t; }
      var lp = ((a - min) / (max - min)) * 100;
      var rp = ((b - min) / (max - min)) * 100;
      fill.style.left = lp + '%';
      fill.style.width = (rp - lp) + '%';
      tmin.style.zIndex = Number(tmin.value) > (max - (max - min) / 12) ? 5 : 4;
    }
    function live(e) {
      if (Number(tmin.value) > Number(tmax.value)) {
        if (e && e.target === tmin) tmin.value = tmax.value;
        else tmax.value = tmin.value;
      }
      paint();
      gte.value = Number(tmin.value) <= min ? '' : fmtAR(Number(tmin.value));
      lte.value = Number(tmax.value) >= max ? '' : fmtAR(Number(tmax.value));
    }
    function commit() {
      gte.dispatchEvent(new Event('change', { bubbles: true }));
      lte.dispatchEvent(new Event('change', { bubbles: true }));
      gte.dispatchEvent(new Event('input', { bubbles: true }));
    }
    tmin.addEventListener('input', live);
    tmax.addEventListener('input', live);
    tmin.addEventListener('change', commit);
    tmax.addEventListener('change', commit);
    gte.addEventListener('change', function () {
      var v = parseAR(gte.value);
      tmin.value = v == null ? min : Math.max(min, Math.min(v, max));
      paint();
    });
    lte.addEventListener('change', function () {
      var v = parseAR(lte.value);
      tmax.value = v == null ? max : Math.max(min, Math.min(v, max));
      paint();
    });
    paint();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.pep__sku') : null;
    if (!b) return;
    e.preventDefault();
    var sku = b.getAttribute('data-sku') || '';
    if (navigator.clipboard && sku) {
      navigator.clipboard.writeText(sku).then(function () {
        b.classList.add('is-copied');
        setTimeout(function () { b.classList.remove('is-copied'); }, 1200);
      }).catch(function () {});
    }
  });

  function setup() { moveTopBar(); openPrice(); buildSlider(); buildSort(); }

  if (document.readyState !== 'loading') setup();
  else document.addEventListener('DOMContentLoaded', setup);

  /* Solo observamos si hay facetas en la pagina (coleccion o busqueda) */
  if (document.querySelector('.facets-vertical-sort') || facetScope()) {
    var sortBar = document.querySelector('.facets-vertical-sort');
    var target = (sortBar && sortBar.closest('.shopify-section')) || document.querySelector('.facets-vertical') || document.body;
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        moveTopBar();
        buildSlider();
        buildSort();
      });
    });
    obs.observe(target, { childList: true, subtree: true });
  }
})();
